<template>
	<div class="address-view" :style="{ '--height': height, }">
		<div class="index-view-top">
			<van-icon @click="toBack" name="arrow-left" size="28" color="#ffffff" />
			<div class="title">{{ $t("head.add_address") }}</div>
			<van-icon style="opacity: 0" name="ellipsis" size="28" color="#ffffff" />
		</div>

		<van-cell-group inset style="margin-bottom: .25rem">
			<van-field v-model="account" maxlength="34" :placeholder="tips" />
		</van-cell-group>
		<div class="tips">{{ $t("address.warmprompt") }}</div>
		<div class="nowLogin" @click="toBind">
			<div>
				<p>{{ $t("add_address.save") }}</p>
			</div>
		</div>
	</div>
</template>

<script>
import {
	bind
} from "@/utils/request";
export default {
	data() {
		return {
			account: '',
			height: '',//屏幕高度
			tips: this.$t("add_address.money_address"),//请输入钱包地址（TRC20）
		};

	},
	//获取屏幕高度
	created() {
		let h = document.documentElement.clientHeight || document.body.clientHeight;
		if (h > 0) {
			this.height = h + 'px' //页面高度
		} else {
			this.height = "100vh"
		}
	},
	mounted() { },
	methods: {
		toBack() {
			this.$router.push("/user");
		},
		//暂不绑定钱包地址
		toLuckyHash() {
			this.$router.push("/luckyhash");
		},
		//绑定钱包地址
		toBind() {
			if (this.account && this.account.slice(0, 1) == 'T' && this.account.length == '34') {
				bind({
					address: this.account
				}).then((res) => {
					if (res.code == "200") {
						this.$toast.success(this.$t("phone.bsuccess"));
						setTimeout(() => {
							this.$router.go("-1");
						}, 500);
					} else {
						this.$toast.success(res.msg);
					}
				});
			} else {
				this.$toast.fail(this.$t("prompt.buzhengque"));
			}
		},
	},
};
</script>

<style lang="scss" scoped>
.index-view-top {
	height: 3.625rem;
	padding: 0 0.9375rem;
	display: flex;
	align-items: center;
	justify-content: space-between;

	.title {
		font-size: 1.125rem;
		font-family: PingFang SC-Bold, PingFang SC;
		font-weight: bold;
		color: #ffffff;
	}
}

.address-view {
	width: 100vw;
	height: var(--height);
	background: #000000;

	.tips {}

	.nowNoLogin {
		padding: 0 1.875rem;
		margin-bottom: 0.9375rem;

		>div {
			width: 100%;
			height: 2.6875rem;
			border: 0.0625rem solid #f8c007;
			border-radius: 1.375rem;
			display: flex;
			align-items: center;
			justify-content: center;

			>p {
				font-size: 0.9375rem;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #f8c007;
			}
		}
	}

	.nowLogin {
		padding: 0 1.875rem;
		margin-bottom: 0.9375rem;

		>div {
			width: 100%;
			height: 2.6875rem;
			background: linear-gradient(180deg, #ffdb67 0%, #f8c007 100%);
			border-radius: 1.375rem;
			display: flex;
			align-items: center;
			justify-content: center;

			>p {
				font-size: 0.9375rem;
				font-family: PingFang SC-Medium, PingFang SC;
				font-weight: 500;
				color: #0c0b0b;
			}
		}
	}

	.van-hairline--top-bottom::after,
	.van-hairline-unset--top-bottom::after {
		border: unset;
	}

	/deep/ .van-field__control {
		color: #ffffff !important;
		font-size: 0.8125rem;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 500;
	}

	.van-cell {
		background: #161414;
		//border-radius: 1.375rem;
	}

	.van-cell-group {
		background: #161414;
		// border-radius: 1.375rem;
	}

	.address-view-title {
		font-size: 1.125rem;
		font-family: PingFang SC-Bold, PingFang SC;
		font-weight: bold;
		color: #ffffff;
		text-align: center;
		padding: 0.9375rem 0;
	}

	.tips {
		font-size: 0.8125rem;
		font-family: PingFang SC-Medium, PingFang SC;
		font-weight: 500;
		color: #ffffff;
		padding: 0 0.9375rem 0.9375rem;
	}

	.prompt {
		display: flex;
		padding: 0.9375rem;

		>img {
			display: block;
			width: 1rem;
			height: 1rem;
			margin-right: 0.125rem;
		}

		>div {
			font-size: 0.8125rem;
			font-family: PingFang SC-Regular, PingFang SC;
			font-weight: 400;
			color: #999999;
		}
	}
}
</style>



// WEBPACK FOOTER //
// src/user/add_address.vue